import React from 'react';
import '../../styles/CashFundCategories.css';

const CATEGORIES = [
  "ALL", 
  "LEARNING ESSENTIAL",
  "EXPERIENCE",
  "GEARS",
  "GROWING UP"
];

const CashFundCategories = ({ selected, onSelect }) => (
  <div className="categories-container">
    {CATEGORIES.map((category) => (
      <span
        key={category}
        onClick={() => onSelect(category)}
        className={`category-item${selected === category ? ' selected' : ''}`}
      >
        {category}
      </span>
    ))}
  </div>
);

export default CashFundCategories;
